import { useState } from "react";
import {
  Box,
  Text,
  Flex,
  Input,
  Button,
  HStack,
  Link,
  Checkbox,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { useSession } from "next-auth/react";
import { getAccount } from "utils/sessionHelper";
import { searchPeople } from "controllers/list";
import { getFormattedContacts } from "./utils"
import { textStyle } from "theme/names";

const isNumeric = (str) => {
  if (typeof str != "string") return false;
  //@ts-ignore
  return !isNaN(str) && !isNaN(parseFloat(str));
};

export function TweetInteraction({ addPeople }) {
  const [postLink, setPostLink] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [like, setLike] = useState<boolean>(false);
  const [reply, setReply] = useState<boolean>(false);
  // const [retweet, setRetweet] = useState<boolean>(false);
  const { data: session } = useSession() ?? {}

  const handleImport = async () => {
    if (!postLink) {
      toast.error("Invalid post url");
      return;
    }
    if (!postLink.includes("linkedin.com")) {
      toast.error("Can't read the post, please check your link");
      return;
    }

    if (!like && !reply) {
      toast.error("Please select atleast 1 interaction");
      return;
    }

    setIsLoading(true);

    let actions: string[] = [];
    if (like) actions.push("like");
    if (reply) actions.push("reply");
    // if (retweet) actions.push("retweet");

    const dataToSend: any = {
      idUser: getAccount(session)?.id,
      idLinkedin: getAccount(session)?.idLinkedin,
      from: "post",
      url: postLink,
      actions: actions.join(","),
      nbContactsToFetchedFromPost: getAccount(session)?.subscription?.plan === "enterprise" ? 500 : 100,
    };

    const data = await searchPeople(session, dataToSend);

    setIsLoading(false);

    if (!data?.success) {
      // if (data?.error)
      //   toast.error(data.error);
      // else
      toast.error("We had an error while importing people from the post - contact us if this issue persists");
      return;
    }

    if (data.contacts.length === 0) {
      toast.success(`No ${actions.join(",")} found from the post`);
      return;
    }

    const formattedList = getFormattedContacts(data.contacts)

    setPostLink("");
    setLike(false);
    setReply(false);
    // setRetweet(false);

    addPeople(formattedList);
  };

  return (
    <Box>
      <Text textStyle={textStyle["h4.medium.standard"]} >
        Import people from a specific post
      </Text>
      <Text textStyle={textStyle["body.medium.light"]} mt={1} fontSize="">
        Will import people who have performed desired action on the specified
        post.
      </Text>
      <Text textStyle={textStyle["body.medium.light"]} fontSize="" mt={1  }>Max 100 people for standard accounts</Text>
      <Text textStyle={textStyle["body.medium.light"]} fontSize="" mt={0  }>
        Max 500 people for pro accounts (
        <Link href="/pricing">upgrade here</Link>)
      </Text>
      <Flex mt="4">
        <Input
          // size="sm"
          width="sm"
          value={postLink}
          borderRadius="lg"
          onChange={(e) => setPostLink(e.target.value)}
          isDisabled={isLoading}
          placeholder="https://www.linkedin.com/feed/update/urn:li:activity:6903292606512451584/"
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleImport();
            }
          }}
        />
        <Button ml="4"
          // size="sm"
          onClick={handleImport} isLoading={isLoading} variant="primary">
          Import
        </Button>
      </Flex>
      <HStack mt="2" spacing="5" ml="2">
        <Checkbox
          fontWeight="medium"
          // size="sm"
          isChecked={like}
          onChange={async (e) => {
            setLike(!like);
          }}
        >
          Likes
        </Checkbox>
        <Checkbox
          fontWeight="medium"
          // size="sm"
          isChecked={reply}
          onChange={async (e) => {
            setReply(!reply);
          }}
        >
          Replies
        </Checkbox>
        {/* <Checkbox
          fontWeight="medium"
          size="sm"
          isChecked={retweet}
          onChange={async (e) => {
            setRetweet(!retweet);
          }}
        >
          Retweets
        </Checkbox> */}
      </HStack>
    </Box>
  );
}
